<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      width="30%"
      :before-close="closeFn">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="词库">
          <el-input v-model="form.label" style="width: 90%;"></el-input>
        </el-form-item>
        <el-form-item label="适用年级">
          <el-input v-model="form.label2" style="width: 90%;"></el-input>
        </el-form-item>
        <el-form-item label="比赛类型">
          <el-input v-model="form.label3" style="width: 90%;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'wordGroupAdd',
  props: {
    show: Boolean,
    title: String
  },
  data () {
    return {
      form: {
        label: '',
        label2: '',
        label3: ''
      }
    }
  },

  methods: {
    submitFn () {
      this.$emit('submit')
    },
    closeFn () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.add{
  font-size: 22px;
  color: #409EFF;
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  top: 4px;
}
</style>
